var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHomeRoof(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.25 7.44051L12.9314 2.91692C12.5963 2.67704 12.4288 2.55709 12.246 2.5107C12.0845 2.46974 11.9154 2.46974 11.754 2.5107C11.5712 2.55709 11.4037 2.67704 11.0686 2.91692L4.74997 7.44053M19.25 7.44051L21.5 9.05132M19.25 7.44051V15.4501C19.25 17.1303 19.25 17.9703 18.923 18.6121C18.6354 19.1766 18.1764 19.6355 17.6119 19.9231C16.9702 20.2501 16.1301 20.2501 14.45 20.2501H9.54997C7.86982 20.2501 7.02974 20.2501 6.388 19.9231C5.82352 19.6355 5.36457 19.1766 5.07695 18.6121C4.74997 17.9703 4.74997 17.1303 4.74997 15.4501V7.44053M4.74997 7.44053L2.5 9.05132",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeRoof);
export default __webpack_public_path__ + "static/media/home-roof.d623e4ecb06347b9ec8bf92b31deec00.svg";
export { ForwardRef as ReactComponent };